// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J14w","col":"styles_col__uLTll"};